import { Stack } from '@mui/system';
import { FormattedMessage } from 'react-intl';

import { ApiWorkflowDialog, DialogMessageBox } from '@verantos-dev/shared-components';
import { startCase } from '@verantos-dev/shared-utils';

import { useProcessCohortDefinitionModal } from './useProcessCohortDefinitionModal';
import { useProcessCohortDefinitionModalString } from './useProcessCohortDefinitionModalString';

export const ProcessCohortDefinitionModal = () => {
  const {
    title,
    cohortName,
    onClose,
    onSubmit,
    isInitialLoading,
    initialLoadingError,
    postCohortExecutionError,
    latestStatus,
    isPostCohortExecutionLoading,
    isSubmitting,
    submittingError,
    onRedirectAfterSubmit,
  } = useProcessCohortDefinitionModal();

  const { apiWorkflowDialogMessages, dialogContentMessages } =
    useProcessCohortDefinitionModalString(cohortName);

  return (
    <ApiWorkflowDialog
      id="cohortProcessDialog"
      title={title}
      dialogMessages={apiWorkflowDialogMessages}
      isInitialLoading={isInitialLoading}
      initialLoadingError={initialLoadingError}
      submittingError={postCohortExecutionError || submittingError}
      isSubmitting={isPostCohortExecutionLoading || isSubmitting}
      onSubmit={onSubmit}
      onClose={onClose}
      onRedirectAfterSubmit={onRedirectAfterSubmit}
      hideDisplayButtonsOnSuccess
    >
      <DialogMessageBox
        id="process-cohort-message-box"
        title={dialogContentMessages.title}
        type="info"
        renderSubmitted={
          <Stack gap={4}>
            <div>{dialogContentMessages.message1}</div>
            <div>
              <FormattedMessage
                id="projects.cohortBuilderPage.processCohortDefinitionModal.message2"
                values={{
                  draft: (
                    <strong style={{ fontWeight: 700 }}>
                      {startCase((latestStatus || '')?.toLowerCase())}
                    </strong>
                  ),
                  processing: (
                    <strong style={{ fontWeight: 700 }}>{dialogContentMessages.processing}</strong>
                  ),
                }}
              />
            </div>
            <div>
              <FormattedMessage
                id="projects.cohortBuilderPage.processCohortDefinitionModal.message3"
                values={{
                  processed: (
                    <strong style={{ fontWeight: 700 }}>{dialogContentMessages.processed}</strong>
                  ),
                }}
              />
            </div>
          </Stack>
        }
      />
    </ApiWorkflowDialog>
  );
};
